import { AloBaseLg, getDefaultAloBaseLg } from "./AloBaseLg"


export interface AloIconLg extends AloBaseLg  {        
}

export const getDefaultAloIconLg = ():AloIconLg => {
    return {
        ...getDefaultAloBaseLg("en")
    }
}